import { Routes, Route } from 'react-router-dom';
import { Router } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { COMPLIANCE_PATH } from './constants';
import ComplianceReportRouter from './complianceReport/ComplianceReportRouter';
import { EMPLOYEE_COMPLIANCE_REPORT_READ } from 'domain/shared/employee';
import ComplianceRegistryRouter from './complianceRegistry/ComplianceRegistryRouter';
import { UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS } from 'domain/shared/compliance';

const preparePath = (path: string): string => {
  return path.replace(COMPLIANCE_PATH, '');
};

const ComplianceRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();

  return (
    <Routes>
      <Route
        path={preparePath(ComplianceReportRouter.getRouterPath())}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[EMPLOYEE_COMPLIANCE_REPORT_READ]}>
            <ComplianceReportRouter />
          </GlobalProtectedRoute>
        }
      />

      <Route
        path={preparePath(ComplianceRegistryRouter.getRouterPath())}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[UPLOAD_COMPLIANCE_REGISTRY_DOCUMENTS]}>
            <ComplianceRegistryRouter />
          </GlobalProtectedRoute>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

ComplianceRouter.getRouterPath = () => `${COMPLIANCE_PATH}/*`;

export default ComplianceRouter;
